import {Util,showErrorDialog} from "baziigram"
import {STORAGE_KEY} from "../constants"
import appService from '../Service'

export const GetUser=()=>
{
let user = {};
try
{
user = JSON.parse(Util.Storage.get(STORAGE_KEY.GAME_USER)) || {};
}
catch(error){ console.error(error)}

if(Object.keys(user).length==0 && window && window.android != undefined && window.android.getData())
 {

     user=JSON.parse(window.android.getData()) || {}
     if(typeof user.accessToken==='undefined' || typeof user.refreshToken==='undefined')
     {UpdateUser(null)
     return {}
     }

     //if(user && user!="null" && user.refreshToken && user.accessToken)
    // UpdateUser(user)
}

return user
}

export const UpdateUser=(newValues)=>
{
if(newValues==null)
{
let u = JSON.stringify({})
if(window && window.android != undefined)
window.android.sendData(u)

localStorage.removeItem(STORAGE_KEY.GAME_USER)
return
}
let user = GetUser();

Object.keys(newValues).map(key=>{
if(key!="code" && key!="message")
user[key] = newValues[key];
})

Util.Storage.save(STORAGE_KEY.GAME_USER, JSON.stringify(user));
if(window && window.android != undefined)
{
   window.android.sendData(JSON.stringify(user))
}

}